import React, { useCallback, useEffect } from "react";
import { EventTable } from "../eventTable/EventTable";
import history from "../../../history/history";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions/allActions";
import * as leState from "../listEventsReducer";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";
import BreadCrumb from "../../../components/breadcrumbs/BreadCrumb";
import ConsoleHelper from "../../../utils/logger";

export const ListEventsPage: React.FC = () => {
  const { events, initLoading } = useSelector(leState.getListEventsState);
  const dispatch = useDispatch();

  //TODO: Tee nämä actionit kunnolla!
  const openEvent = (eventId: string, subEventId?: string) => {
    ConsoleHelper(eventId, subEventId);
    if (subEventId) {
      dispatch(allActions.eventActions.getEventDetails(eventId, subEventId));
      dispatch(allActions.eventActions.getSubEventDetails(subEventId));
      history.push(`/events/${eventId}/subevents/${subEventId}`);
    } else {
      dispatch(allActions.eventActions.getEventDetails(eventId));
      history.push(`/events/${eventId}`);
    }
  };

  const getAllEvents = useCallback(() => {
    dispatch(allActions.eventActions.getAllEvents({ date: "0", limit: "100" }));
  }, [dispatch]);

  useEffect(() => {
    getAllEvents();
  }, [getAllEvents]);

  return (
    <div className='w-screen h-screen container flex-col'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} lastChild={true} />
      </BreadRoute>
      <EventTable list={events} openEvent={openEvent} loading={initLoading} />
    </div>
  );
};

export default ListEventsPage;
